<mat-card>
    <mat-card-header>
        <mat-card-title>{{location.core.name}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-divider></mat-divider>
        <p><b>Operator:</b> {{location.operator.name}}</p>
        <p><b>Status:</b> {{location.locationStatus.locationStatus}}</p>
        <p><b>Location Code:</b> {{location.locationTypeCodes.locationTypeCode}}</p>
        <p><b>Time Zone:</b> {{location.core.timeZone.timeZoneId}}</p>
    </mat-card-content>
</mat-card>